import React from 'react';
import { useHistory } from 'react-router';

interface ServiceOptionProps {
  text: string;
  route: string;
}

const ServiceOption: React.FC<ServiceOptionProps> = ({ text, route }) => {
  const history = useHistory();

  return (
    <button
      type='button'
      className='bg-beaver text-white text-xl font-raleway my-4 py-6 px-10 rounded-full text-left'
      onClick={() => history.push(route)}
    >
      {text}
    </button>
  );
};

export default ServiceOption;
